import React from 'react'
import ClientProfileTop from '../clientProfileTop/ClientProfileTop'
import ClientReview from '../clientReview/ClientReview'
import ClientFollow from '../clientFollow/ClientFollow'

const ClientProfile = () => {
  return (
    <div className='dashboard-content-box dashboard-profile'>
        <div className='top-profile-box'>
            <ClientProfileTop />
        </div>
        <div className='client-reviews-sec'>
          <ClientReview />
        </div>
        <div className='client-bottom-follow-sec'>
            <ClientFollow />
        </div>
    </div>
  )
}

export default ClientProfile